export function levenshtein(a, b) {
    if (a === b)
        return 0;
    const m = a.length;
    const n = b.length;
    if (m === 0)
        return n;
    if (n === 0)
        return m;
    // Keep the inner array width minimal (standard Wagner-Fischer with O(min)
    // space). Computing the shorter string along the columns avoids allocating
    // an (m+1)×(n+1) matrix on every call — this function is the fuzzy stage's
    // hot inner loop.
    if (m > n)
        return levenshtein(b, a);
    let prev = new Array(n + 1);
    let curr = new Array(n + 1);
    for (let j = 0; j <= n; j++)
        prev[j] = j;
    for (let i = 1; i <= m; i++) {
        curr[0] = i;
        const aChar = a.charCodeAt(i - 1);
        for (let j = 1; j <= n; j++) {
            const cost = aChar === b.charCodeAt(j - 1) ? 0 : 1;
            curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        }
        const tmp = prev;
        prev = curr;
        curr = tmp;
    }
    return prev[n];
}
function collectAll(node, prefix, results, limit) {
    if (results.length >= limit)
        return;
    for (const term of node.terminal) {
        if (!results.includes(term)) {
            results.push(term);
            if (results.length >= limit)
                return;
        }
    }
    for (const [char, child] of Object.entries(node.children)) {
        collectAll(child, prefix + char, results, limit);
        if (results.length >= limit)
            return;
    }
}
export function fuzzyAutocomplete(root, prefix, limit = 10) {
    const exact = trieAutocompleteFuzzy(root, prefix, limit);
    if (exact.length >= limit)
        return exact;
    const results = new Set(exact);
    collectFuzzy(root, prefix.toLowerCase(), '', 1, results, limit);
    return Array.from(results).slice(0, limit);
}
function trieAutocompleteFuzzy(root, prefix, limit) {
    let node = root;
    for (const char of prefix.toLowerCase()) {
        node = node?.children[char];
        if (!node)
            return [];
    }
    const results = [];
    collectAll(node, prefix, results, limit);
    return results;
}
function collectFuzzy(node, target, current, maxDist, results, limit) {
    if (results.size >= limit)
        return;
    if (current.length > target.length + maxDist)
        return;
    // Only add terms whose own edit distance to the query is within tolerance.
    // (Previously the whole subtree was added when the *prefix path* matched,
    // which flooded the limit with near-prefix siblings like "Electrical…"
    // and starved the intended typo target e.g. "Electrician".)
    for (const term of node.terminal) {
        if (levenshtein(term.toLowerCase(), target) <= maxDist) {
            results.add(term);
            if (results.size >= limit)
                return;
        }
    }
    for (const [char, child] of Object.entries(node.children)) {
        collectFuzzy(child, target, current + char, maxDist, results, limit);
        if (results.size >= limit)
            return;
    }
}
//# sourceMappingURL=autocomplete.js.map